import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const RegularRoute = () => {
  return (
    <>
      <Navbar />
      <div className="h-10"></div>
      <div className="flex flex-col flex-[1] items-stretch justify-stretch">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default RegularRoute;
